import { Component, OnInit } from "@angular/core";
import moment from "moment";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { AppMessageSeverity } from "src/app/shared/models/enums/AppMessageSeverity.enum";
import { OOCanvas } from "src/app/shared/models/oo-canvas";
import { OOMenu } from "src/app/shared/models/oo-menu";
import { v4 as uuidv4 } from "uuid";

@Component({
	selector: "app-custom-menu-setup",
	templateUrl: "./custom-menu-setup.component.html",
	styleUrls: ["../../commandcenter.scss"],
})
export class CustomMenuSetupComponent implements OnInit {
	assignedCanvases: OOCanvas[];
	assignableCanvases: OOCanvas[];

	baseUrl: string;

	customMenuSelected: OOMenu;
	changesToSave: boolean = false;

	loaded: boolean = false;

	moment: any = moment;

	newRecord: boolean = false;

	reorder: boolean = false;

	constructor(public app: AppService, private focuslink: FocuslinkService, public venueService: OOVenueService) {}

	ngOnInit(): void {
		if (this.venueService.subscriptionOOmenu.value.length === 0) {
			this.venueService.menuGet();
		}

		if (this.venueService.subscriptionOOcanvas.value.length === 0) {
			this.venueService.canvasesGet();
		}
		this.baseUrl = window.location.hostname;
		if (this.baseUrl === "localhost") {
			this.baseUrl = `http://localhost:4200`;
		} else if (this.baseUrl.includes("dev")) {
			this.baseUrl = "https://dev.onlineorder.focuspos.com";
		} else {
			this.baseUrl = "https://onlineorder.focuspos.com";
		}
	}

	selectCustomMenu(rec: OOMenu) {
		if (this.venueService.subscriptionOOcanvas.value.length > 0) {
			this.customMenuSelected = rec;
		} else {
			this.app.msgSvc.add({ severity: AppMessageSeverity.YELLOW, summary: "", detail: `Canvases are not loaded. Please wait.` });
		}
	}

	async customMenuAdd() {
		if (this.venueService.subscriptionOOcanvas.value.length > 0) {
			this.venueService.subscriptionOOcanvas.subscribe((ooCanvas) => {
				this.assignableCanvases = this.venueService.subscriptionOOcanvas.value.filter((i) => i.online);
			});
		} else {
			this.assignableCanvases = this.venueService.subscriptionOOcanvas.value.filter((i) => i.online);
		}

		this.customMenuSelected = new OOMenu({
			key: uuidv4(),
			venueKey: this.venueService.subscriptionVenue.value.key,
			active: false,
			unsaved: true,
		});
	}

	async onDefaultMenuChange(rec: OOMenu, active: boolean) {
		if (active) {
			this.app.confirmation.confirm({
				message: `Are you sure you want to make ${rec.name} the default menu? All visitors to your normal url ${
					this.baseUrl + "/" + this.venueService.subscriptionVenue.value.key
				} will go to this menu.`,
				accept: async () => {
					rec.active = true;
					this.venueService.subscriptionOOmenu.value.find((i) => i.key === rec.key).active = true;
					this.venueService.subscriptionOOmenu.value.forEach((ooMenu) => {
						ooMenu.active = false;
					});
					await this.venueService.menuSave(this.venueService.subscriptionOOmenu.value);
				},
				reject: async () => {
					this.app.confirmation.close();
				},
			});
		} else {
			const menu = this.venueService.subscriptionOOmenu.value.find((i) => i.key === rec.key);
			menu.active = false;
			await this.venueService.menuSave(menu);
		}
	}
}
